import { Tab, TabProps } from '@mui/material';

export const SearchTab = ({ sx, ...rest }: TabProps) => {
  return <Tab sx={{ paddingX: 3.5, paddingTop: 2.5, ...sx }} {...rest}></Tab>;
};
